import React from 'react';

import { Inline, type InlineProps } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const controlsStyles = cssMap({
	root: {
		width: '100%',
		gap: token('space.050'),
	},
	// Default styles for the layout section
});

export const Controls: React.FC<
	React.PropsWithChildren<Pick<InlineProps, 'alignBlock' | 'spread'>>
> = ({ children }) => {
	return (
		<Inline xcss={controlsStyles.root} alignInline="end">
			{children}
		</Inline>
	);
};
